import type { MappingPayload } from '@/types/Mapping'

/** The mapping form as the API reads it, a multipart request so the map can go along. */
export function mappingFormData(payload: MappingPayload, image: File | null): FormData {
  const formData = new FormData()

  if (image) {
    formData.append('image', image)
  }

  formData.append('name', payload.name)
  formData.append('local_id', payload.locationId)
  formData.append('has_sector_selection', payload.hasSectorSelection ? '1' : '0')
  // Rows and seats are edited in the seat editor, which saves them itself: the form leaves them alone
  formData.append('sectors', JSON.stringify(payload.sectors.map(sector => ({
    ...sector,
    sections: sector.sections.map(({ rows: _rows, ...section }) => section),
  }))))

  return formData
}
